import { Application } from "@hotwired/stimulus"
import HubspotIdentifyController from "../controllers/hubspot_identify_controller"

function debugEnabled() {
  // Quick one-off: add ?debug_hubspot_identify=1
  // Persistent: localStorage.setItem("hubspotIdentifyDebug", "1")
  if (window.location.search.includes("debug_hubspot_identify=1")) {
    return true
  }

  try {
    return window.localStorage.getItem("hubspotIdentifyDebug") === "1"
  } catch (_error) {
    return false
  }
}

function logMissingControllerElementWarning() {
  if (!debugEnabled()) return

  const hasControllerElement = document.querySelector('[data-controller~="hubspot-identify"]')
  if (hasControllerElement) return

  // Helps identify when a page is missing the HubSpot data-controller hook.
  console.warn("[hubspot-identify] No element with data-controller=\"hubspot-identify\" was found. Check analytics/hubspot enabled conditions for this page.")
}

function registerHubspotIdentifyController() {
  const application = window.Stimulus || Application.start()

  if (!window.Stimulus) {
    window.Stimulus = application
  }

  try {
    application.register("hubspot-identify", HubspotIdentifyController)
  } catch (error) {
    if (!`${error}`.includes("already been registered")) {
      throw error
    }
  }

  logMissingControllerElementWarning()
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", registerHubspotIdentifyController, { once: true })
} else {
  registerHubspotIdentifyController()
}
